/**
 * Redux slice for UI state.
 *
 * Manages:
 * - UI-specific state that needs to be shared across components
 * - Modal open/close states
 * - View toggles (e.g., timeline vs. risk assessment)
 *
 * Pattern: Follows smartSlice.ts pattern with simple synchronous reducers.
 */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    showAssessmentHistory: false,
    hasActiveSleepOrder: false,
    isManageAlertModalOpen: false,
    snackbarMessage: null,
    snackbarSeverity: 'info'
};
const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        /**
         * Set whether to show assessment history
         */
        setShowAssessmentHistory: (state, action) => {
            state.showAssessmentHistory = action.payload;
        },
        /**
         * Toggle assessment history view
         */
        toggleAssessmentHistory: (state) => {
            state.showAssessmentHistory = !state.showAssessmentHistory;
        },
        /**
         * Set whether the patient has an active sleep order (drives disabling of
         * action buttons such as "Update prediction", independent of which panel
         * is currently displayed).
         */
        setHasActiveSleepOrder: (state, action) => {
            state.hasActiveSleepOrder = action.payload;
        },
        /**
         * Open manage alert modal
         */
        openManageAlertModal: (state) => {
            state.isManageAlertModalOpen = true;
        },
        /**
         * Close manage alert modal
         */
        closeManageAlertModal: (state) => {
            state.isManageAlertModalOpen = false;
        },
        /**
         * Show snackbar with message
         */
        showSnackbar: (state, action) => {
            state.snackbarMessage = action.payload.message;
            state.snackbarSeverity = action.payload.severity || 'info';
        },
        /**
         * Close snackbar
         */
        closeSnackbar: (state) => {
            state.snackbarMessage = null;
        },
        /**
         * Clear all UI state
         */
        clearUi: () => {
            return Object.assign({}, initialState);
        }
    }
});
export const { setShowAssessmentHistory, toggleAssessmentHistory, setHasActiveSleepOrder, openManageAlertModal, closeManageAlertModal, showSnackbar, closeSnackbar, clearUi } = uiSlice.actions;
export default uiSlice.reducer;
